import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { useNotification } from '../../providers/notificationsProvider';
import { API_URL, getCachedSessionId } from '../../services/common';

const createResource = async ({ resource, projectId }) => {
  const response = await axios.post(
    `${API_URL}/v1/project/${projectId}/provider/hosting/resource`,
    resource,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};

export const useCreateResource = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotification();
  return useMutation(createResource, {
    onError: (error) => {
      notify({ message: error.message, severity: 'error' });
    },
    onSuccess: () => {
      notify({ message: 'Resource was added successfully', severity: 'success' });
      queryClient.invalidateQueries(['resources']);
    }
  });
};
